<template>
  <div class="container" ref="container" v-if="items" :key="rkey">

    <Head v-if="meta"></Head>
    <Header />
    <Navigation />
    <Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>
    <main :class="main_class">
      <collection-head v-if="this.$route.name == 'Collection'" :total="total" />
      <search-results-head v-if="this.$route.name == 'Search'" :total="total" />
      <photos-head v-if="this.$route.name == 'Photos'" :total="total" />
      <documents-head v-if="this.$route.name == 'Documents'" :total="total" />
      <showpieces-head v-if="this.$route.name == 'Showpieces'" :total="total" />
      <tag-head v-if="this.$route.name == 'Tags'" :total="total" />
      <exhibits-head v-if="this.$route.name == 'Exhibits'" :total="total" :featured="featured" />
      <exhibit-head v-if="this.$route.name == 'Exhibit'" :total="total" />
      <recordings-head v-if="this.$route.name == 'Recordings'" :total="total" />
      <biogram-head v-if="this.$route.name == 'BiogramRelated'" :total="total" />
      <Grid :items="items" :total="total" :page="page" v-if="total && ok" :title="title" :key="rkey" />
    </main>
    <Footer />
  </div>
</template>

<script>

import axios from "axios";
import NProgress from "nprogress";

import JsonURL from "@jsonurl/jsonurl";

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";
import Grid from "@/components/Common/Grid/Grid.vue";

// heads

import CollectionHead from "@/components/Heads/CollectionHead.vue";
import SearchResultsHead from "@/components/Heads/SearchResultsHead.vue";
import DocumentsHead from "@/components/Heads/DocumentsHead.vue";
import PhotosHead from "@/components/Heads/PhotosHead.vue";
import ShowpiecesHead from "@/components/Heads/ShowpiecesHead.vue";
import TagHead from "@/components/Heads/TagHead.vue";
import ExhibitsHead from "@/components/Heads/ExhibitsHead.vue";
import ExhibitHead from "@/components/Heads/ExhibitHead.vue";
import BiogramHead from "@/components/Heads/BiogramHead.vue";
import RecordingsHead from "@/components/Heads/RecordingsHead.vue";

import { eventBus } from "@/main.js";

export default {
  name: "Listing",
  // items from
  props: ["apiCall", "breadcrumbsTitle"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      meta: null,
      breadcrumbs: null,
      page: null,
      items: null,
      total: null,
      rkey: Math.random(),
      title: this.breadcrumbsTitle,
      main_class: "search-results",
      ok: false,
      img_class: null,
      featured: null,
    };
  },
  components: {
    Head,
    Header,
    Navigation,
    Breadcrumbs,
    Footer,
    Grid,
    CollectionHead,
    SearchResultsHead,
    DocumentsHead,
    ShowpiecesHead,
    PhotosHead,
    TagHead,
    ExhibitsHead,
    ExhibitHead,
    BiogramHead,
    RecordingsHead,
  },
  methods: {
    setMainClass() {
      if (this.$route.name == "Collection" || this.$route.name == "Exhibit")
        this.main_class = "exhibition-page bottom-bg search-bg";
    },
    generatePaths(id) {
      // id = item.item_type.id
      if (id == 20) return "/fotografia";
      if (id == 19) return "/dokument";
      if (id == 24) return "/eksponat";
      if (id == 18) return "/biogram";
      if (id == 28) return "/nagranie";
    },
    fetchData() {
      NProgress.start();
      //console.log("fetchData");
      //console.log('fetchData')

      let _api_uri =
        this.$config.API_PATH + this.apiCall + "&sort_field=id&sort_dir=d&page=" + this.page;

      if (this.$route.name == "Exhibits")
        _api_uri = this.$config.API_PATH + this.apiCall + "?sort_field=id&sort_dir=d&page=" + this.page;
      //console.log(_api_uri);

      // if there is already advanced object and api_uri

      if (this.$route.name == "Collection") {
        // item order need this
        //console.log("collection");
        _api_uri = this.$config.API_PATH + this.apiCall + "&page=" + this.page;
      }

      if (
        this.$route.params.query &&
        this.$route.params.query.indexOf("___") > -1
      ) {
        //console.log(this.$route.params.query);

        let _advanced_query = decodeURI(
          this.$route.params.query.replace("___", "")
        );
        // uri decoding error fix
        _advanced_query = _advanced_query.replace("%3F", "=?");

        _api_uri =
          this.$config.API_PATH + _advanced_query + "&sort_field=id&sort_dir=d&page=" + this.page;
      }

      //console.log(_api_uri);

      axios
        .get(_api_uri)
        .then((_resp) => {
          //console.log(_resp);
          if (_resp.data.length == 0) {
            /* this.$router.push({
              name: "NotFound",
            }); */
          }

          //this.items = _resp.data;
          this.total = _resp.headers["omeka-total-results"];

          this.items = [];

          // prepare items for displaying

          //console.log(_resp.data)

          _resp.data.forEach((_item, order) => {

            if (this.$route.name == "Exhibits") {

              this.items.push({
                id: _item.slug,
                title: _item.title,
                img_url: _item.ckc_cover_image,
                type: 0,
                path: "wystawa",
              });

              if (!this.featured) {
                if (_item.is_featured) this.featured = _item;
              }

            } else {
              // building titles
              let _metadata = _item.element_texts;
              let _title = "Brak tytułu";
              if (_metadata.find((x) => x.element.id == "50"))
                _title = _metadata.find((x) => x.element.id == "50").text;

              if (_metadata.find((x) => x.element.id == "52"))
                _title = _metadata.find((x) => x.element.id == "52").text;

              // we need parse biograms too :/
              if (_item.item_type.id !== 18) {
                axios
                  .get(this.$config.API_PATH + "files?item=" + _item.id + "&sort_field=order&sort_dir=a")
                  .then((_img) => {
                    // cacth errors pls

                    let i = _img.data[0].file_urls.fullsize;


                    //console.log(_img.data);

                    let _this = this;

                    this.img_class = "";

                    const img = new Image();
                    img.onload = function () {
                      //console.log([this.width,this.height]);
                      if (this.height < 500 && this.width >= 800) _this.img_class = "wide";
                      //console.log(_this.img_class);
                      if (!i) {
                        _img.data.forEach((e) => {
                          if (e.has_derivative_image === true) {
                            i = e.file_urls.fullsize;
                          }
                        });
                      }

                      // dodac order i po orderze


                      _this.items.push({
                        id: _item.id,
                        order: order,
                        title: _title,
                        img_url: i,
                        type: _item.item_type.id,
                        path: _this.generatePaths(_item.item_type.id),
                        img_class: _this.img_class
                      });
                      if (this.$route.name !== "Collection") {
                        // item order need this 
                        this._items.sort((a, b) => (a.id > b.id) ? 1 : -1)
                        this._items.reverse()
                      } else {
                        this._items.sort((a, b) => a.order - b.order);
                      }

                      // dodac order i po orderze

                      console.log(this._items)
                    }



                    img.src = i;


                  });
              } else {
                // biograms
                axios
                  .get(this.$config.API_PATH + "files?item=" + _item.id + "&sort_field=id&sort_dir=a")
                  .then((_img) => {
                    // cacth errors pls

                    let _image = require("@/assets/img/blank_portrait.jpg");

                    if (_img.data.length > 0)
                      _image = _img.data[0].file_urls.fullsize;

                    this.items.push({
                      id: _item.id,
                      title: _title,
                      order: order,
                      img_url: _image,
                      type: _item.item_type.id,
                      path: this.generatePaths(_item.item_type.id),
                    });
                    if (this.$route.name !== "Collection") {
                      this.items.sort((a, b) => (a.id > b.id) ? 1 : -1)
                      this.items.reverse()
                    } else {
                      this.items.sort((a, b) => a.order - b.order);
                    }
                  });
              }
            }
          });
        })
        .catch((error) => {
          //console.log(error);
          this.$router.push({
            name: "NotFound",
          });
        });

      setTimeout(function () {
        NProgress.done();
      }, 500);
    },
    buildBreadcrumbs() {
      this.breadcrumbs = {
        parent_title: "",
        parent_uri: "",
        self_title: "",
        self_uri: window.location.href,
      };

      if (this.$route.name == "Collection") {
        this.breadcrumbs.parent_title = "Kolekcje";
        this.breadcrumbs.parent_uri = "/kolekcje";
      }
      if (this.$route.name == "Tags") {
        this.breadcrumbs.parent_title = "Etykiety";
        this.breadcrumbs.parent_uri = "/etykiety";
      }
      if (this.$route.name == "BiogramRelated") {
        eventBus.$on('passBiogramTitle', (name) => {
          this.breadcrumbs.parent_title = name;
          this.breadcrumbs.parent_uri = "/biogram/" + this.$route.params.id;
        })
      }
    },
  },
  beforeMount() {
    if (typeof this.$route.params.page == "undefined") {
      this.page = 1;
    } else {
      this.page = this.$route.params.page;
    }
  },
  mounted() {
    this.setMainClass();
    this.fetchData();
    this.buildBreadcrumbs();

    let _this = this;

    eventBus.$on("headLoaded", () => {
      //this.ok = true;

      let _this = this;

      setTimeout(function () {
        _this.ok = true;
      }, 500);
    });

    eventBus.$on("changePage", (p) => {
      this.page = p;
      //console.log(p)
      let _this = this;
      //this.rkey = Math.random()
      this.$router.push({ name: _this.$router.name, params: { page: p } });
      this.fetchData();
    });
  },
  watch: {
    apiCall() {
      //console.log('apiCall watched')
      this.rkey = Math.random();
      this.setMainClass();
      this.page = 1;
      this.fetchData();
      this.buildBreadcrumbs();
    },
    $route() {
    },
    page() {
    }
  },
};
</script>

<style>
img.wide {
  max-width: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Listing.vue